export const ENABLE = 'reward.enable';
export const IMAGE = 'reward.floating_button_web.image';
export const URL = 'reward.floating_button_web.url';
